<script>
    import FormRow from "../../../components/FormRow.svelte";
    import DisplayRow from "../../../components/FormRow.svelte";
    import FormColumn from "../../../components/FormColumn.svelte";
    import TextDisplay from "../../../components/TextDisplay.svelte";

    export let medicareNumber = null;
    export let medicareRef = null;
    export let disabled = false;
    export let isValid = true;

    let medicareNumberRequired = !!medicareNumber;

    let medicareError = false;
    let medicareErrorMessage = "Please provide a valid Medicare Number";

    const validateMedicare = (e) => {
        isValid = true;
        medicareError = false;
        let weightArray = [1, 3, 7, 9, 1, 3, 7, 9];
        let m = e.target.value.replace(/ /g, '');

        if (m.length === 0) {
            return;
        };

        if (m.length !== 10) {
            medicareError = true;
            isValid = false;
        };

        let sum = 0;
        for (let i = 0; i < 8; i++) {
            sum += (weightArray[i] * parseInt(m[i], 10));
        }

        if (sum % 10 !== parseInt(m[8], 10)) {
            medicareError = true;
            isValid = false;
        }
    }

</script>

<div>

    {#if medicareNumberRequired || disabled}

        <DisplayRow>
            <FormColumn cols="10">
				<TextDisplay label="Medicare number" value={medicareNumber} />
            </FormColumn>
            <FormColumn cols="2">
				<TextDisplay label="Ref" value={medicareRef} />
            </FormColumn>
        </DisplayRow>

    {:else}

        <FormRow>
            <FormColumn cols="10">
                <label for="medicare">Medicare Number</label>
                <input type="number" bind:value="{medicareNumber}" id="medicare" class="form-control" maxlength="10" on:blur="{(e) => validateMedicare(e)}" />
                {#if medicareError}
                    <div class:error-message="{medicareError}">{medicareErrorMessage}</div>
                {/if}
            </FormColumn>
            <FormColumn cols="2">
                <label for="ref">Ref</label>
                <input type="number" bind:value="{medicareRef}" id="ref" class="form-control" />
            </FormColumn>
        </FormRow>

    {/if}

</div>




